import React, { useEffect } from 'react';
import { InputQuillProps } from './types';
import { Area, StyledFormGroup } from './input-quill.styles';
import { ErrorMessageInput } from '../error-message-input/error-message-input';
import { useQuill } from 'react-quilljs';
import { TOOLBAR_OPTIONS } from './options';

export const InputQuill: React.FC<InputQuillProps> = ({
    error,
    label,
    hint,
    value,
    placeholder,
    required,
    disabled,
    onChange,
}) => {
    const { quillRef, quill } = useQuill({
        placeholder,
        modules: { toolbar: TOOLBAR_OPTIONS },
        theme: 'snow',
    });

    useEffect(() => {
        const handler = () => {
            const html = quill?.root.innerHTML;
            if (onChange) {
                onChange(html || '');
            }
        };

        quill?.on('text-change', handler);

        return () => {
            quill?.off('text-change', handler);
        };
    }, [quill]);

    useEffect(() => {
        if (quill) {
            quill.clipboard.dangerouslyPasteHTML(value);
        }
    }, [quill]);

    useEffect(() => {
        if (disabled) {
            quill?.disable();
        } else {
            quill?.enable();
        }
    }, [quill, disabled]);

    return (
        <StyledFormGroup
            $disabled={disabled}
            label={label}
            required={required}
            $error={error}
            errorMessage={<ErrorMessageInput error={error} hint={hint} />}>
            <Area ref={quillRef} />
        </StyledFormGroup>
    );
};

InputQuill.displayName = 'InputQuill';
